// extracted by mini-css-extract-plugin
export default {"row":"NewProduct_row__uVLi8","col":"NewProduct_col__-NAHq","card":"NewProduct_card__b+Pb3"};